import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_deal_hdr_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface
  revision: fromDatatype.GuidDataFieldInterface
  vrsn: fromDatatype.VarcharDatatypeInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
  sales_lead_hdr_guid: fromDatatype.GuidDataFieldInterface;
  source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  type_hdr_guid: fromDatatype.GuidDataFieldInterface;
  stage_hdr_guid: fromDatatype.GuidDataFieldInterface;
  organization_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rating_hdr_guid: fromDatatype.GuidDataFieldInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  firstname: fromDatatype.VarcharArrayDatatypeInterface;
  lastname: fromDatatype.VarcharArrayDatatypeInterface;
  probability: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharArrayDatatypeInterface;
  nationality: fromDatatype.VarcharDatatypeInterface;
  ethnicity: fromDatatype.VarcharDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  region_code: fromDatatype.VarcharDatatypeInterface;
  last_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  next_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  target_start_date: fromDatatype.TimestampTzDatatypeInterface;
  target_end_date: fromDatatype.TimestampTzDatatypeInterface;
  reporter: fromDatatype.GuidDataFieldInterface;
  assignee: fromDatatype.GuidDataFieldInterface;
}

export class bl_sfa_deal_hdr_RowClass implements bl_sfa_deal_hdr_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface
  revision: fromDatatype.GuidDataFieldInterface
  vrsn: fromDatatype.VarcharDatatypeInterface;
  project_guid: fromDatatype.GuidDataFieldInterface;
  sales_lead_hdr_guid: fromDatatype.GuidDataFieldInterface;
  source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  type_hdr_guid: fromDatatype.GuidDataFieldInterface;
  stage_hdr_guid: fromDatatype.GuidDataFieldInterface;
  organization_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rating_hdr_guid: fromDatatype.GuidDataFieldInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  firstname: fromDatatype.VarcharArrayDatatypeInterface;
  lastname: fromDatatype.VarcharArrayDatatypeInterface;
  probability: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  dob: fromDatatype.TimestampTzDatatypeInterface;
  gender: fromDatatype.VarcharArrayDatatypeInterface;
  nationality: fromDatatype.VarcharDatatypeInterface;
  ethnicity: fromDatatype.VarcharDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  region_code: fromDatatype.VarcharDatatypeInterface;
  last_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  next_follow_up_date: fromDatatype.TimestampTzDatatypeInterface;
  target_start_date: fromDatatype.TimestampTzDatatypeInterface;
  target_end_date: fromDatatype.TimestampTzDatatypeInterface;
  reporter: fromDatatype.GuidDataFieldInterface;
  assignee: fromDatatype.GuidDataFieldInterface;
}
